import { mapGetters } from 'vuex'

export const BaseAnimation = {
  // Enables an abstract component in Vue.
  // This property is undocumented and may change at any time,
  // but your component should work without it.
  abstract: true,
  computed: {
    ...mapGetters({
      preloader: 'common/preloader'
    })
  },
  data() {
    return {
      observer: null
    }
  },
  watch: {
    preloader(value) {
      if (value === false) {
        this.animation()
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      if (!this.preloader) this.animation()
    })
  },

  // Yay, render functions!
  render() {
    try {
      // Without using a wrapper component, we can only render one child component.
      return this.$slots.default[0]
    } catch (e) {
      throw new Error(
        'IntersectionObserver.vue can only render one, and exactly one child component.'
      )
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}



// WEBPACK FOOTER //
// ./mixins/BaseAnimation.js